var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraduationCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8217_1924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5485 11.9835L33.6497 3.93283C29.9299 1.71091 25.3 1.67149 21.5429 3.8297L4.45397 11.9835C4.38984 12.0156 4.32334 12.0499 4.26147 12.0866C0.206079 14.4054 -1.20179 19.5727 1.11702 23.6281C1.90302 25.0029 3.0592 26.1293 4.45397 26.8793L9.16796 29.1252V40.3543C9.17076 45.3755 12.438 49.8116 17.2323 51.3039C20.5688 52.2691 24.0283 52.7417 27.5013 52.7064C30.9739 52.7453 34.4334 52.2767 37.7703 51.3154C42.5647 49.8232 45.8319 45.387 45.8347 40.3658V29.1206L50.4181 26.9297V45.8313C50.4181 47.097 51.4441 48.123 52.7097 48.123C53.9753 48.123 55.0013 47.097 55.0013 45.8313V18.3313C55.0166 15.6403 52.8918 13.1543 50.5485 11.9835ZM41.2512 40.3658C41.2524 43.3692 39.3038 46.0259 36.4387 46.9268C33.5334 47.757 30.5227 48.1599 27.5012 48.1231C24.4798 48.1599 21.4691 47.757 18.5637 46.9268C15.6987 46.0258 13.75 43.3692 13.7512 40.3658V31.3092L21.3527 34.93C23.2283 36.0438 25.3704 36.629 27.5517 36.6236C29.628 36.6383 31.6693 36.0886 33.4573 35.0332L41.2512 31.3091V40.3658ZM48.5846 22.7428L31.3008 30.9928C28.8909 32.3961 25.9039 32.3563 23.5321 30.8897L6.62185 22.846C4.73692 21.8295 4.03288 19.4775 5.0493 17.5927C5.39305 16.9553 5.90846 16.4269 6.53709 16.0672L23.7131 7.86307C26.1238 6.46293 29.1092 6.50257 31.4819 7.9662L48.3806 16.0168C49.6234 16.7069 50.4009 18.01 50.4179 19.4314C50.4201 20.7779 49.7268 22.03 48.5846 22.7428Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8217_1924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationCap);
export default __webpack_public_path__ + "static/media/graduation-cap.37d28ff1f929d8da868845b0c285a659.svg";
export { ForwardRef as ReactComponent };